import * as PIXI from "pixi.js";
import { Container, Text, Graphics } from "@inlet/react-pixi";
import { TextStyle } from "pixi.js";
import { useState, useMemo, useEffect } from "react";

const Question = ({ question, options, rightAnswer, onAnswer }) => {
  const [selected, setSelected] = useState(null);

  const handleOption = (idx) => {
    setSelected(idx);
    const isRight = options[idx] === rightAnswer;
    if (onAnswer)
      setTimeout(() => {
        onAnswer(isRight);
      }, 500);
  };

  const buttonStyle = (active) =>
    new TextStyle({
      fontFamily: "Arial",
      fontSize: 24,
      fill: active ? "#fff" : "#333",
      fontWeight: "bold",
    });

  const maxTextWidth = useMemo(() => {
    const style = buttonStyle(false);
    return Math.max(
      ...options.map((opt) => {
        const metrics = PIXI.TextMetrics.measureText(opt, style);
        return metrics.width;
      })
    );
  }, [options]);

  useEffect(() => {
    setSelected(null);
  }, [question, options, rightAnswer]);

  const rectWidth = Math.ceil(maxTextWidth + 40); // 20px padding a cada lado

  return (
    <Container
      position={[window.innerWidth / 2, window.innerHeight / 2]}
      anchor={0.5}
    >
      <Text
        text={question}
        style={
          new TextStyle({
            fontFamily: "Arial",
            fontSize: 32,
            fill: "#005baa",
            fontWeight: "bold",
            wordWrap: true,
            wordWrapWidth: rectWidth, // Ajusta el ancho al del contenedor de opciones
          })
        }
        anchor={0.5}
        x={0}
        y={-120}
      />
      {options.map((opt, i) => (
        <Container
          key={i}
          interactive
          pointerdown={() => handleOption(i)}
          position={[-rectWidth / 2, -50 + i * 60]}
        >
          <Graphics
            draw={(g) => {
              g.clear();
              g.beginFill(selected === i ? 0x005baa : 0xffffff);
              g.lineStyle(2, 0x005baa, 1);
              g.drawRoundedRect(0, 0, rectWidth, 50, 12);
              g.endFill();
            }}
          />
          <Text
            interactive
            text={opt}
            style={buttonStyle(selected === i)}
            x={rectWidth / 2}
            y={25}
            anchor={0.5}
          />
        </Container>
      ))}
    </Container>
  );
};

export default Question;
